import { Title, Video } from '~/components'

export function Review() {
  return (
    <div>
      <Title label="Rückblick" spacing="xlarge">
        Das war 2024!
      </Title>
      <Video src="https://s3.eu-central-1.amazonaws.com/digital.next-step.li/20240927_digicube_nextstep.mp4" />
    </div>
  )
}
